import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="text-center mt-5">
      <h1 className="display-4">404</h1>
      <p>Page not found</p>
      <Link to="/" className="btn btn-success">
        Go Home
      </Link>
    </div>
  );
}
